module.exports = __webpack_public_path__ + "static/media/retos_logo.b1f8470f.png";